export default __webpack_public_path__ + "static/media/mia.483d3351.jpeg";